import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../types";

// Base selector - Fetches cronJobsTracker from the state
const selectCronJobsTracker = (state: RootState) => state.cronJobsTracker || { cronJobsTrackerData: null };

// Memoized selector - Ensures performance optimization
export const getCronJobTrackerDataDetails = createSelector(
  selectCronJobsTracker,
  (cronJobsTracker) => cronJobsTracker
);